import React, { JSX } from 'react';
import { FormConfig, InputElement } from '../types/types';
import FormInput from './FormInput';

interface Props {
  config: InputElement;
  keySuffix?: FormConfig['keySuffix'];
}

const InputWrapper = (props: Props): JSX.Element => {
  const {
    config: {
      id,
      tag,
      key,
      ariaLabel,
      label,
      placeholder,
      boldLabel,
      showErrorIcon,
      disabled,
      disablePaste,
      type,
      onFocus,
      onBlur,
      onChange,
      ignoreTypeSwitchInMobile,
      ignoreTypeSwitchInDesktop,
      customCheckboxElement,
      autoComplete,
      helperText,
      validateOnBlurOnly,
      showSuccessState
    },
    keySuffix
  } = props;

  return (
    <FormInput
      id={id}
      tag={tag}
      ariaLabel={ariaLabel}
      name={`${key}${keySuffix || ''}`}
      label={label}
      boldLabel={boldLabel}
      showErrors
      placeholder={placeholder}
      showErrorIcon={showErrorIcon}
      disabled={disabled}
      disablePaste={disablePaste}
      type={type}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={onChange}
      ignoreTypeSwitchInMobile={ignoreTypeSwitchInMobile}
      ignoreTypeSwitchInDesktop={ignoreTypeSwitchInDesktop}
      customCheckboxElement={customCheckboxElement}
      autoComplete={autoComplete}
      helperText={helperText}
      validateOnBlurOnly={validateOnBlurOnly}
      showSuccessState={showSuccessState}
    />
  );
};

export default InputWrapper;
